import { Popover, PopoverContent, PopoverTrigger } from '@chain-zen/ui'

import type { UserDetails } from '../../types/user'
import { MembersAvatarButton } from './members-avatar-button'

interface IMembersDropdown {
  buttonText: string
  handleOpenChange: () => void
  isOpen: boolean
  popoverContent: React.ReactNode
  selectedUsersAvatar: UserDetails[]
}

/**
 * This component is used to display a dropdown to add and remove dispatchers or drivers or team members for a shipment.
 */
export const MembersDropdown = ({
  buttonText,
  isOpen,
  popoverContent,
  selectedUsersAvatar,
  handleOpenChange
}: IMembersDropdown) => {
  return (
    <div className="relative w-full">
      <Popover open={isOpen} onOpenChange={handleOpenChange} modal={true}>
        <PopoverTrigger asChild={true}>
          <div className="w-full">
            <MembersAvatarButton
              members={selectedUsersAvatar}
              onClick={() => handleOpenChange()}
              buttonText={buttonText}
            />
          </div>
        </PopoverTrigger>
        <PopoverContent
          className="w-[calc(100vw-4rem)] max-w-[448px] p-2 shadow-none"
          align="end"
          side="bottom"
          sideOffset={4}
        >
          {popoverContent}
        </PopoverContent>
      </Popover>
    </div>
  )
}
